import { FormattedMessage } from "react-intl";
import AddUserForSupportIcon from "../../../../components/Common/SvgIcons/AdminIcons/OrganizationSettingsIcons/AddUserForSupportIcon";
import LocationIcon from "../../../../components/Common/SvgIcons/AdminIcons/OrganizationSettingsIcons/LocationIcon";
import PasswordExpirationIcon from "../../../../components/Common/SvgIcons/AdminIcons/OrganizationSettingsIcons/PasswordExpirationIcon";
import SetupUsersIcon from "../../../../components/Common/SvgIcons/AdminIcons/OrganizationSettingsIcons/SetupUsersIcon";
import UserDepartmentIcon from "../../../../components/Common/SvgIcons/AdminIcons/OrganizationSettingsIcons/UserDepartmentIcon";
import CreateTrainingTypeIcon from "../../../../components/Common/SvgIcons/ManageIcons/CreateTrainingTypeIcon";
import { colors } from "../../../stripeColors";
import { admin } from "../admin";
import OfficeLocation from "../../../../assets/downloads/Office Location.csv";
import UserDepartment from "../../../../assets/downloads/User Department Info.csv";
import UserInformation from "../../../../assets/downloads/User Information.csv";
import HybridUserInformation from "../../../../assets/downloads/AAD/HybridUserCSVInfo.csv";

const getSetupUsersTenantType = () =>
  (localStorage.getItem("SecurityProviderName") || "").toLowerCase();

const isHybridUserTenant = () => {
  const tenantData = JSON.parse(localStorage.getItem("tenantData") || "{}");
  const tenantType = getSetupUsersTenantType();
  return (
    tenantData?.SAMLConfig?.IdentityType === 2 &&
    ["saml2", "custom"].includes(tenantType)
  );
};

const getSetupUsersFileTypeFlag = () => {
  const tenantType = getSetupUsersTenantType();
  if (tenantType === "aad") return 12;
  if (isHybridUserTenant()) return 16;
  if (tenantType === "saml2") return 14;
  return 2;
};

const getSetupUsersDownloadLink = () => {
  if (isHybridUserTenant()) {
    return HybridUserInformation;
  }
  return UserInformation;
};

export const organizationSettings = {
  name: <FormattedMessage id="ONBOARDSETUP_TITLE" />,
  path: (tenantName) => `${admin.path(tenantName)}/organizationSettings`,
  location: {
    name: "Location",
    heading: <FormattedMessage id="ONBOARDSETUP_STORETXT" />,
    path: (tenantName) =>
      `${admin.path(tenantName)}/organizationSettings/location`,
    downloadLink: OfficeLocation,
    fileTypeFlag: 1,
  },
  userDepartment: {
    name: <FormattedMessage id="USERMANAGE_CATEGORY" />,
    heading: <FormattedMessage id="ONBOARDSETUP_PRODCATTXT" />,
    path: (tenantName) =>
      `${admin.path(tenantName)}/organizationSettings/userDepartment`,
    downloadLink: UserDepartment,
    fileTypeFlag: 0,
  },
  setupUsers: {
    name: "Setup Users",
    heading: <FormattedMessage id="ONBOARDSETUP_USERTXT" />,
    path: (tenantName) =>
      `${admin.path(tenantName)}/organizationSettings/setupUsers`,
    downloadLink: getSetupUsersDownloadLink,
    fileTypeFlag: getSetupUsersFileTypeFlag,
  },
  passwordExpiration: {
    name: "Password Expiration",
    heading: "Setup Password Expiration (in Days)",
    path: (tenantName) =>
      `${admin.path(tenantName)}/organizationSettings/passwordExpiration`,
    downloadLink: "",
    fileTypeFlag: 0,
  },
  addUserForSupport: {
    name: "Add User For Support",
    heading: <FormattedMessage id="COPY_ADDITIONAL_USERS" />,
    path: (tenantName) =>
      `${admin.path(tenantName)}/organizationSettings/addUserForSupport`,
    downloadLink: "",
    fileTypeFlag: 0,
  },
  setUpDomainName: {
    name: "Create Domain Name",
    path: (tenantName) =>
      `${admin.path(tenantName)}/organizationSettings/setUpDomainName`,
  },
  createTrainingType: {
    name: "Create Training Type",
    path: (tenantName) =>
      `${admin.path(tenantName)}/organizationSettings/createTrainingType`,
  },
  navLinks: (navigate, tenantName) => [
    {
      key: 1,
      label: admin.name,
      path: admin.path(tenantName),
      onClick: () => navigate(admin.path(tenantName)),
    },
    {
      key: 2,
      label: organizationSettings.name,
      path: `${organizationSettings.path(tenantName)}`,
      onClick: () => navigate(organizationSettings.path(tenantName)),
    },
  ],
  tiles: (navigate, tenantName) => [
    {
      key: 1,
      label: organizationSettings.location.name,
      heading: organizationSettings.location.heading,
      color: colors.lightBlue,
      path: organizationSettings.location.path(tenantName),
      onClick: () => navigate(organizationSettings.location.path(tenantName)),
      icon: (fill) => <LocationIcon fill={fill} />,
      downloadLink: organizationSettings.location.downloadLink,
      fileTypeFlag: organizationSettings.location.fileTypeFlag,
    },
    {
      key: 2,
      label: organizationSettings.userDepartment.name,
      heading: organizationSettings.userDepartment.heading,
      color: colors.purple,
      path: organizationSettings.userDepartment.path(tenantName),
      onClick: () =>
        navigate(organizationSettings.userDepartment.path(tenantName)),
      icon: (fill) => <UserDepartmentIcon fill={fill} />,
      downloadLink: organizationSettings.userDepartment.downloadLink,
      fileTypeFlag: organizationSettings.userDepartment.fileTypeFlag,
    },
    {
      key: 3,
      label: organizationSettings.setupUsers.name,
      heading: organizationSettings.setupUsers.heading,
      color: colors.red,
      path: organizationSettings.setupUsers.path(tenantName),
      onClick: () => navigate(organizationSettings.setupUsers.path(tenantName)),
      icon: (fill) => <SetupUsersIcon fill={fill} />,
      downloadLink: organizationSettings.setupUsers.downloadLink,
      fileTypeFlag: organizationSettings.setupUsers.fileTypeFlag,
    },
    {
      key: 4,
      label: organizationSettings.passwordExpiration.name,
      heading: organizationSettings.passwordExpiration.heading,
      color: colors.darkOrange,
      path: organizationSettings.passwordExpiration.path(tenantName),
      onClick: () =>
        navigate(organizationSettings.passwordExpiration.path(tenantName)),
      icon: (fill) => <PasswordExpirationIcon fill={fill} />,
      downloadLink: organizationSettings.passwordExpiration.downloadLink,
      fileTypeFlag: organizationSettings.passwordExpiration.fileTypeFlag,
      isVisible:
        localStorage.getItem("SecurityProviderName") == "aad" ||
        localStorage.getItem("SecurityProviderName") == "SAML2"
          ? false
          : true,
    },
    {
      key: 5,
      label: organizationSettings.addUserForSupport.name,
      heading: organizationSettings.addUserForSupport.heading,
      color: colors.blue,
      path: organizationSettings.addUserForSupport.path(tenantName),
      onClick: () =>
        navigate(organizationSettings.addUserForSupport.path(tenantName)),
      icon: (fill) => <AddUserForSupportIcon fill={fill} />,
      downloadLink: organizationSettings.addUserForSupport.downloadLink,
      fileTypeFlag: organizationSettings.addUserForSupport.fileTypeFlag,
    },
    {
      key: 6,
      label: organizationSettings.setUpDomainName.name,
      color: colors.lightBlue,
      path: organizationSettings.setUpDomainName.path(tenantName),
      onClick: () =>
        navigate(organizationSettings.setUpDomainName.path(tenantName)),
      icon: (fill) => <CreateTrainingTypeIcon fill={fill} />,
      isVisible:
        localStorage.getItem("SecurityProviderName") == "SAML2" ? true : false,
    },
    {
      key: 7,
      label: organizationSettings.createTrainingType.name,
      color: colors.lightBlue,
      path: organizationSettings.createTrainingType.path(tenantName),
      onClick: () =>
        navigate(organizationSettings.createTrainingType.path(tenantName)),
      icon: (fill) => <CreateTrainingTypeIcon fill={fill} />,
    },
  ],
};
